import { useProjectContext } from "components/pages/FeaturedProjects/contexts/Project";
import { useVote } from "hooks/useVote";
import VoteCard from "../../Votes/VoteCard";
import classes from "./classes.module.scss";

export default function CastingVote() {
	const { project } = useProjectContext();
	const { castingVotes, fetchCastingVotes, userHasVoted } = useVote(project);

	return (
		<div className={classes["root"]}>
			<div className={classes["votes-container"]}>
				{castingVotes.map((voteWithResults) => (
					<VoteCard key={voteWithResults.question.id} voteWithResults={voteWithResults} onVote={fetchCastingVotes} showResults={userHasVoted(voteWithResults.question)} />
				))}
			</div>
		</div>
	);
}
